// extracted by mini-css-extract-plugin
export default {"imageWrapper":"Weswe","image":"odAT0"};